// ChartJSBarChart.jsx
import React from 'react'
import { Bar } from 'react-chartjs-2'
import 'chart.js/auto'

const ChartJSBarChart = ({ data, title }) => {
  const chartData = {
    labels: data.map(item => item.carrierName),
    datasets: [
      {
        label: title,
        data: data.map(item => item.successRate),
        backgroundColor: data.map(item => item.color || '#4CAF50'), // use color from data
        borderRadius: 10,
        barThickness: 22,
        maxBarThickness: 30,
      }
    ]
  }

  const options = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
      legend: { display: false },
      title: { display: false },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.raw}%`
        }
      }
    },
    scales: {
      x: {
        min: 0,
        max: 100,
        ticks: {
          callback: value => `${value}%`,
          font: { size: 13 },
        },
        grid: { color: '#e5e7eb', borderDash: [4, 2] }
      },
      y: {
        ticks: { font: { size: 13 } },
        grid: { display: false }
      }
    },
    animation: {
      duration: 700,
      easing: 'easeOutQuart'
    },
    layout: {
      padding: { top: 20, right: 30, bottom: 10, left: 5 }
    }
  }

  return (
    <div className="w-full h-[360px] flex items-start">
      <Bar data={chartData} options={options} />
    </div>
  )
}

export default ChartJSBarChart
